import { ReactElement } from 'react';
import classNames from 'classnames';
import { Icon } from '@nx-frontend/shared/ui/icon';

interface ActivityParentProps {
  disabled: boolean;
  title: string;
  icon: ReactElement;
  onClick: (e: React.MouseEvent) => void;
}

export function ActivityParent(props: ActivityParentProps) {
  const { disabled, title, icon, onClick } = props;
  return (
    <div
      className={classNames(
        'flex items-center cursor-pointer grow truncate text-nowrap group',
        disabled ? '!cursor-default' : 'cursor-pointer'
      )}
      onClick={onClick}
    >
      <Icon
        icon={icon}
        className={classNames(
          '!w-3 !h-3 text-neutral-500 flex-shrink-0',
          !disabled ? 'group-hover:text-neutral-600 transition-colors duration-200' : ''
        )}
      />
      <div
        data-cy="notif-activity-parent"
        className={classNames(
          'text-neutral-400 w-full font-semibold truncate text-nowrap rounded-md px-1',
          !disabled ? 'group-hover:bg-neutral-200 transition-colors duration-200 group-hover:text-neutral-500' : ''
        )}
      >
        {title}
      </div>
    </div>
  );
}
